import { useState, useEffect } from "react";
import axios from "axios";

export default function useUser() {
    const [ubranch, setUbranch] = useState(null);
    const [ubranchid, setUbranchid] = useState(null);
    const [username, setUsername] = useState(null);
    const [userid, setUserid] = useState(null);
    const [role, setRole] = useState(null);
    const [clntid, setClientid] = useState(null);

    useEffect(() => {
        const storedBranch = localStorage.getItem("branch");
        const storedBranchid = localStorage.getItem("branchid");
        const storedUsername = localStorage.getItem("username");
        const storedUserid = localStorage.getItem("userid");
        const storedRole = localStorage.getItem("role");
        const storedClientid = localStorage.getItem("clientid");

        if (storedUserid) {
            setUbranch(storedBranch);
            setUbranchid(storedBranchid);
            setUsername(storedUsername);
            setUserid(storedUserid);
            setRole(storedRole);
            setClientid(storedClientid);
        }
    }, []);

    const loggedInUser = userid;
    const loggedInUserId = username;
    const selectedBranchId = ubranch;
    const userRole = role;
    const userClient = clntid;

    const logProcess = async (message) => {
        try {
            await axios.post(
                'https://treatway.co.in/Counter-Backend/SalesApi/logProcess',
                { remarks: message },
                {
                    headers: {
                        'User-Id': loggedInUserId,
                        'Branch-Id': selectedBranchId
                    }
                }
            );
        } catch (err) {
            console.error("Failed to log process:", err);
        }
    };

    return {
        loggedInUser,
        loggedInUserId,
        selectedBranchId,
        username,
        ubranch,
        role,
        userRole,
        ubranchid,
        clntid,
        userClient,
        logProcess
    };
}
